import type { UseQueryResult } from '@tanstack/react-query';
import { Link } from 'react-router-dom';

import type { RegionDetail, RegionNode } from '../../../../api/regions';
import { SectionCard } from '../../regional/BucketStates';

import { RegionDetailCard } from './RegionDetailCard';
import { RegionHierarchyTree } from './RegionHierarchyTree';

interface Props {
  regions: RegionNode[];
  colorMap: Map<string, string>;
  selectedId: string | null;
  onSelect: (id: string) => void;
  onReparent: (id: string, parentId: string) => void;
  onNewRegion: () => void;
  detailQuery: UseQueryResult<RegionDetail>;
}

/** Right rail of the Region landing: actions, hierarchy tree, selected detail. */
export function RegionLandingRail({
  regions,
  colorMap,
  selectedId,
  onSelect,
  onReparent,
  onNewRegion,
  detailQuery,
}: Props) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 14, minHeight: 0 }}>
      <div style={{ display: 'flex', gap: 8 }}>
        <button
          type="button"
          className="nb-btn nb-btn-primary"
          style={{ fontSize: 12 }}
          onClick={onNewRegion}
        >
          New region
        </button>
        <Link
          to="/admin/regions/triage"
          className="nb-btn"
          style={{ fontSize: 12, textDecoration: 'none' }}
        >
          Backfill review
        </Link>
      </div>

      <SectionCard title="Regions">
        <div style={{ maxHeight: 300, overflow: 'auto', margin: '0 -6px' }}>
          <RegionHierarchyTree
            regions={regions}
            colorMap={colorMap}
            selectedId={selectedId}
            onSelect={onSelect}
            onReparent={onReparent}
          />
        </div>
      </SectionCard>

      <RegionDetailCard selectedId={selectedId} query={detailQuery} colorMap={colorMap} />
    </div>
  );
}
